import {ActionCreator} from 'redux';
import {Dispatch, ThunkAction} from '../../../../../../../types/actions';
import {IGetState} from '../../../../../../../types/types';
import { boardNameClickedSegmentEvent } from '../../../effects/segmentEvents';
import { ESegmentClickType } from '../../../../../../../middlewares/segment/constants';
import { nameEditing } from '../effects/nameEditing';

export const onDblClickName: ActionCreator<ThunkAction> = () => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(nameEditing());
        dispatch(boardNameClickedSegmentEvent(ESegmentClickType.double));
    };
    return action;
};
